export default __webpack_public_path__ + "static/media/bmg-carnage-logo.65842187.svg";